import { Form } from 'antd';
import { sumBy } from 'lodash';
import { useMemo } from 'react';
import shopSelectors from 'services/shop/selectors';
import { formatCurrency, parseDecimal } from 'utils/formatCurrency';
import Button from '../Button';
import { IGroupCustomerItem } from '../types';
type Props = {
  onClick?: () => void;
  value?: IGroupCustomerItem[];
};
const ButtonDeposit = ({ onClick, value: customers }: Props) => {
  const settingDeposit = shopSelectors.data.settingDepositBooking();
  const form = Form.useFormInstance();
  const depositValue = useMemo(() => {
    if (!settingDeposit) return 0;
    if (settingDeposit?.depositType === 'PERCENT') {
      const total = sumBy(customers, o => o.services.reduce((acc, service) => acc + (service.price || 0), 0) || 0) || 0;
      return parseDecimal(total * (settingDeposit?.depositValue / 100));
    }
    return settingDeposit?.depositValue;
  }, [customers, settingDeposit]);

  const acceptPolicyDeposit = Form.useWatch(['acceptPolicyDeposit'], form);

  if (!settingDeposit?.active) return null;

  return (
    <Button disabled={!acceptPolicyDeposit} onClick={onClick}>PAY ({formatCurrency(depositValue)})</Button>
  );
};

export default ButtonDeposit;
